const mainDashboardNavigation = () => {
    const localStorageKey = 'activeDashboardListing3';

    $('#listing-tails').click(function () {
        localStorage.setItem(localStorageKey,'tails');
        hideAllListings();
        showListingTail();
    });

    $('#listing-list').click(function () {
        localStorage.setItem(localStorageKey,'list');
        hideAllListings();
        showListingList();
    });

    $('#listing-map').click(function () {
        localStorage.setItem(localStorageKey, 'map');
        hideAllListings();
        showListingMap();
    });

    const activeDashboardListing = localStorage.getItem(localStorageKey);

    if (activeDashboardListing) {
        hideAllListings();
        if (activeDashboardListing === 'list') {
            showListingList();
        } else if (activeDashboardListing === 'map') {
            showListingMap();
        } else {
            showListingTail();
        }
    }
};

function hideAllListings() {
    $('#listing-tails, #listing-list, #listing-map').removeClass('active');
    $('.p-main-panel__locations--tails, .p-main-panel__locations--list, .p-main-panel__locations--map')
        .removeClass('p-main-panel__locations--active');
}

function showListingTail() {
    $('#listing-tails').addClass('active');
    $('.p-main-panel__locations--tails').addClass('p-main-panel__locations--active');
}

function showListingList() {
    $('#listing-list').addClass('active');
    $('.p-main-panel__locations--list').addClass('p-main-panel__locations--active');
}

function showListingMap() {
    $('#listing-map').addClass('active');
    $('.p-main-panel__locations--map').addClass('p-main-panel__locations--active');
}

export const mainDashboard = () => {
    mainDashboardNavigation();
};

const showLocationDetails = () => {
    const locations = document.querySelectorAll('.c-location');

    for (let i = 0; i < locations.length; i++) {
        const locationContent = locations[i].querySelector('.c-location__content');
        locationContent.addEventListener('click', () => {
            locations[i].classList.toggle('c-location--expanded');
        });
    }
};
showLocationDetails();
